import { Link } from "react-router-dom";
import { CITIES } from "@/data/content";

export default function LocationsIndex() {
  return (
    <main data-testid="locations-page">
      <section className="py-20 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="text-xs font-bold uppercase tracking-widest text-sky-800">Service Areas</span>
            <h1 className="editorial-title text-4xl sm:text-5xl text-[#0a1b2a] mt-2 font-normal">
              Water is local. So are we.
            </h1>
            <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">
              Oklahoma water is not one thing. What comes out of a tap in Edmond differs from Tulsa, and a
              private well outside Yukon is a different conversation entirely. Choose your city for an honest
              look at what homeowners in your area commonly encounter — and what to test before buying anything.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {CITIES.map((c) => (
              <Link key={c.slug} to={`/locations/${c.slug}`} data-testid={`city-card-${c.slug}`}
                className="group p-6 rounded-2xl bg-[#f8fbff] border border-slate-200 hover:border-sky-300 hover:shadow-md transition">
                <span className="text-xs font-bold uppercase tracking-wider text-sky-800">{c.region}</span>
                <h2 className="text-xl font-bold text-slate-900 mt-2 group-hover:text-sky-800 transition">{c.name}</h2>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{c.headline}</p>
                <span className="inline-block mt-4 text-xs font-semibold text-sky-700 group-hover:text-sky-900">
                  See {c.name} water details →
                </span>
              </Link>
            ))}
          </div>

          <div className="mt-12 p-6 rounded-2xl bg-[#0a1b2a] text-white flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-base font-bold">Don't see your town?</h3>
              <p className="text-sm text-slate-300 mt-1">
                We serve communities across the OKC and Tulsa metros. Request a free analysis and we'll confirm coverage for your address.
              </p>
            </div>
            <Link to="/#contact" data-testid="locations-index-cta"
              className="inline-flex shrink-0 px-6 py-3 bg-sky-300 hover:bg-sky-200 text-slate-950 rounded-xl text-sm font-bold transition">
              GET MY FREE WATER ANALYSIS
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
